<template>
  <footer class="web-footer">
    <div class="footer-box">
      <div class="web-main">
        <div class="footer-nav">
          <router-link to='about'>关于我们</router-link>
          <router-link to='statement'>网站声明</router-link>
          <router-link to='contact'>联系我们</router-link>
        </div>
        <div class="footer-p">
          <p @click="linkUrl('https://rmtzx.zyxrmtzx.com/user_back/my_back_card/audiovisual_card/')">网络视听许可证104420069号</p>
          <p @click="linkUrl('http://beian.miit.gov.cn')">晋ICP备2020014062号-1</p>
        </div>

        <div class="footer-icp" @click="linkUrl('http://www.beian.gov.cn/portal/index.do')">
          <img src="../assets/images/common/icp.png" />
          <span>晋公网安备14112902000017</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: "web-footer",
    data() {
      return {

      }
    },
    mounted: function() {

    },
    methods: {
      // 跳转链接 start
      linkUrl(url) {
        window.open(url, '_blank');
      }
      // 跳转链接 end
    }
  }
</script>

<style scoped>
  .web-footer {
    width: 100%;
    background-image: url(../assets/images/common/footer.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
  }

  .footer-box {
    width: 100%;
    height: 100%;
    background: rgba(31, 55, 86, .5);
    padding: 120px 0;
  }

  .footer-nav {
    height: 25px;
    line-height: 25px;
    display: flex;
    justify-content: center;
  }

  .footer-nav a {
    margin: 0 31px;
    font-size: 18px;
    color: #FFFFFF;
  }

  .web-footer .footer-p {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }

  .web-footer .footer-p p {
    color: #FFFFFF;
    font-size: 16px;
    cursor: pointer;
    height: 25px;
    line-height: 25px;
    margin-left: 20px;
  }

  .web-footer .footer-p p:first-child {
    margin-left: 0;
  }

  .footer-icp {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    font-size: 16px;
    margin-top: 22px;
    cursor: pointer;
  }

  .footer-icp img {
    margin-right: 10px;
  }

  @media screen and (max-width: 800px) {
    .footer-box {
      padding: 88px 0;
    }

    .footer-nav {
      justify-content: space-around;
    }

    .footer-nav a {
      margin: 0;
      font-size: 14px;
    }

    .web-footer .footer-p {
      display: block;
      text-align: center;
    }

    .web-footer .footer-p p {
      font-size: 14px;
      margin-top: 10px;
    }

    .web-footer .footer-p p:first-child {
      margin: 0;
    }

    .footer-icp {
      font-size: 14px;
      margin-top: 16px;
    }

    .footer-icp img {
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue